import UserContext from 'components/General/UserContext';
import React, { useContext, useRef, useEffect } from 'react';
import { iframeResizer } from 'iframe-resizer';

export default function Analytics(props) {
  const { theme } = useContext(UserContext);
  const isDarkTheme = theme === 'dark';

  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeResizer(
        {
          heightCalculationMethod: 'taggedElement',
          onInit: function () {
            const iframe = iframeRef.current;
            const styles = iframe.getAttribute('styles');
            if (styles) {
              iframe.iFrameResizer.sendMessage({
                type: 'load-custom-styles',
                opts: { styles: styles },
              });
            }
          },
          checkOrigin: false,
        },
        iframeRef.current,
      );
    }
  }, []);

  return (
    <>
      <iframe
        ref={iframeRef}
        src={`https://analytics.travelfeed.com/share/${
          props.blog.domain
            ? props.blog.domain.replace(/^https?:\/\/(www\.)?/, '')
            : `${props.blog.id}.truvvl.blog`
        }?auth=${props.blog.analyticsApi}&embed=true&theme=${
          isDarkTheme ? 'dark' : 'light'
        }&background=%23${isDarkTheme ? '353F44' : 'FFFFFF'}`}
        scrolling="no"
        frameBorder="0"
        loading="lazy"
        style={{ width: '1px', minWidth: '100%', height: '1600px' }}
      />
      <div className="tw-text-sm">
        Stats powered by{' '}
        <a
          target="_blank"
          rel="nofollow noreferrer noopener"
          className="tw-underline tw-text-primary-500"
          href="https://plausible.io"
        >
          Plausible Analytics
        </a>
      </div>
    </>
  );
}
